import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoKey16 = t0 => {
  const $ = _c(10);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  let t3;
  if ($[2] !== iconColor) {
    t2 = <path d="M10.3333 9.50001C12.4504 9.50001 14.1667 7.78374 14.1667 5.66668C14.1667 3.54958 12.4504 1.83334 10.3333 1.83334C8.21627 1.83334 6.5 3.54958 6.5 5.66668C6.5 5.98795 6.53952 6.29998 6.61397 6.5982L2.69526 10.5169C2.57024 10.6419 2.5 10.8115 2.5 10.9883V12.8334C2.5 13.2015 2.79848 13.5001 3.16667 13.5001H5.01173C5.18855 13.5001 5.35811 13.4298 5.48314 13.3048L6.16667 12.6213V10.8334H7.95453L9.40187 9.38608C9.70007 9.46048 10.0121 9.50001 10.3333 9.50001Z" stroke={iconColor} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M11.4998 5.66667C11.4998 6.311 10.9775 6.83333 10.3332 6.83333C9.68884 6.83333 9.1665 6.311 9.1665 5.66667C9.1665 5.02233 9.68884 4.5 10.3332 4.5C10.9775 4.5 11.4998 5.02233 11.4998 5.66667Z" stroke={iconColor} strokeWidth={1.5} strokeLinecap="square" />;
    $[2] = iconColor;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2 || $[8] !== t3) {
    t4 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default IcoKey16;